import {useCodelists} from 'services/codelists';
import {useThesauruses} from 'services/thesaurus';
import type {SchemaDataAccess} from 'schema/contexts';

export const appSchemaDataAccess: SchemaDataAccess = {
  useCodelists,
  useThesauruses,
};
